<template>
  <select
    data-test-id="epoch-size-selector"
    ref="epochSizeSelect"
    class="form-select me-2 max-w-150"
    v-model="selectedEpochSize"
    @change="changeLocation"
  >
    <option v-for="(i, k) in timelineLookup" :key="k" :value="i.inSeconds">
      {{ i.label }}
    </option>
  </select>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getEpochUrl } from '../../get-epoch-url';
import { router } from '@/router';
import { timelineLookup } from './epoch-size-select.constants';
import { correctingEpochNomenclature } from './epoch-size-select.utils';

export default defineComponent({
  name: 'EpochSizeSelect',
  props: {
    epochSize: {
      type: String,
      required: true,
      default: '30'
    }
  },
  data() {
    return {
      timelineLookup,
      selectedEpochSize: this.epochSize as string
    };
  },
  computed: {
    scoreSetData() {
      return this.$store.getters['scoreSet/getScoreSet'];
    }
  },
  methods: {
    changeLocation() {
      const { id, epochSize, epochSelected } = this.$route.params;

      const epochCalculated = correctingEpochNomenclature(
        +epochSize,
        +this.selectedEpochSize,
        +epochSelected
      );

      const newUrl = getEpochUrl(id as string, this.selectedEpochSize, epochCalculated);

      router.push({
        path: newUrl,
        query: { ...this.$route.query }
      });
      (this.$refs.epochSizeSelect as HTMLSelectElement).blur();
    }
  },
  watch: {
    epochSize() {
      if (this.selectedEpochSize !== this.epochSize) {
        this.selectedEpochSize = this.epochSize;
      }
    }
  }
});
</script>
